<section>
  <div class="container">
      <div class="row align-items-center">
          <div class="col-12 col-md-6">
              <div class="row">
                <div class="col offset-md-1 mb-lg-3">
                  <h2 class="heading-xl">Seite nicht gefunden</h2>
                  <a routerLink="/home"  class="btn btn-primary btn-round btn-lg mt-4">Zur Startseite</a>
                </div>
              </div>
          </div>
      </div>
  </div>
</section>